import { styled } from 'goober';

/* stylelint-disable property-no-vendor-prefix */
const StyledSelect = styled.select`
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  border: 1px solid #c5c7d4;
  box-sizing: border-box;
  border-radius: 6px;
  padding: 8px 12px;
  width: 100%;
  font-family: 'Noto Sans', sans-serif;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.02em;
  color: #242527;
  outline: none;
  background: #ffffff url('/assets/new-teacher/Select/Select.svg') no-repeat;
  background-position: right 8px center;
`;

const Select = ({ options, value, onChange, className = '' }) => (
  <StyledSelect onChange={onChange} className={className}>
    {options.map((option) => (
      <option
        key={option.value}
        value={option.value}
        selected={value === option.value ? 'true' : undefined}
      >
        {option.label}
      </option>
    ))}
  </StyledSelect>
);

export default Select;
